/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_First_LabelInputs */

const en_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First Event`)
};

const fr_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premier événement`)
};

const de_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Veranstaltung`)
};

const it_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primo evento`)
};

const ru_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Первое событие`)
};

const es_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primer evento`)
};

const zh_cn2_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首场活动`)
};

const ja_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初のイベント`)
};

const hi_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहला आयोजन`)
};

const pt_pt2_audio_description_export_selection_first_label = /** @type {(inputs: Audio_Description_Export_Selection_First_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeiro evento`)
};

/**
* | output |
* | --- |
* | "First Event" |
*
* @param {Audio_Description_Export_Selection_First_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_first_label = /** @type {((inputs?: Audio_Description_Export_Selection_First_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_First_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_selection_first_label(inputs)
	if (locale === "de") return de_audio_description_export_selection_first_label(inputs)
	if (locale === "it") return it_audio_description_export_selection_first_label(inputs)
	if (locale === "ru") return ru_audio_description_export_selection_first_label(inputs)
	if (locale === "es") return es_audio_description_export_selection_first_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_selection_first_label(inputs)
	if (locale === "ja") return ja_audio_description_export_selection_first_label(inputs)
	if (locale === "hi") return hi_audio_description_export_selection_first_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_selection_first_label(inputs)
	return en_audio_description_export_selection_first_label(inputs)
});